import python from './../../documents/picturs/python.png';
import are from './../../documents/picturs/are.png';
import csharp from './../../documents/picturs/csharp.jpg';
import rust from './../../documents/picturs/rust.png';

import clang from './../../documents/picturs/clang.png';
import java from './../../documents/picturs/java.png';
import typescript from './../../documents/picturs/typescript.png';
import kotlin from './../../documents/picturs/kotlin.png';
import perl from './../../documents/picturs/perl.png';
import scala from './../../documents/picturs/scala.png';


import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image'

import MyCard from './../MyCard.js';

class AndroidApps extends React.Component{
  render(){
    return(
      <div>
      <Alert variant="success">
        <h3>
          Apprendre la programmation: cours + exemples
        </h3>
      </Alert>


        <Row className="ml-1 mr-1">
          <Col xs="4" md="3" lg="2" sm="s">
          <Card className="mt-5 shadow-lg" className="text-center">
                <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.pythonGuide&hl=en">
                <Card.Title>Python</Card.Title>
                <Image src={python} fluid rounded className="shadow-lg"/>
                Download
                </Card.Link>
                </Card>
          </Col>

          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                  <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.rust&hl=en">
                  <Card.Title>Rust</Card.Title>
                  <Image src={rust} fluid rounded className="shadow-lg"/>
                  Download
                  </Card.Link>
                  </Card>
          </Col>


          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.are&hl=en">
                <Card.Title>R-lang</Card.Title>
                <Image src={are} fluid rounded className="shadow-lg"/>
                Download
                </Card.Link>
                </Card>
          </Col>

          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                  <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.Csharp&hl=en">
                  <Card.Title>C-sharp</Card.Title>
                  <Image src={csharp} fluid rounded className="shadow-lg"/>
                  Download
                  </Card.Link>
                  </Card>
          </Col>

          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.perl&hl=en">
                <Card.Title>Perl</Card.Title>
                <Image src={perl} fluid rounded className="shadow-lg"/>
                Download
                </Card.Link>
                </Card>
          </Col>

          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                  <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.kotlin&hl=en">
                  <Card.Title>Kotlin</Card.Title>
                  <Image src={kotlin} fluid rounded className="shadow-lg"/>
                  Download
                  </Card.Link>
                  </Card>
          </Col>
        </Row>

<br/>


        <Row className="ml-1 mr-1">
          <Col xs="4" md="3" lg="2" sm="s">
          <Card className="mt-5 shadow-lg" className="text-center">
                <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.scala&hl=en">
                <Card.Title>Scala</Card.Title>
                <Image src={scala} fluid rounded className="shadow-lg"/>
                Download
                </Card.Link>
                </Card>
          </Col>

          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                  <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.learnc&hl=en">
                  <Card.Title>C-lang</Card.Title>
                  <Image src={clang} fluid rounded className="shadow-lg"/>
                  Download
                  </Card.Link>
                  </Card>
          </Col>


          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.JavaGuide&hl=en">
                <Card.Title>Java</Card.Title>
                <Image src={java} fluid rounded className="shadow-lg"/>
                Download
                </Card.Link>
                </Card>
          </Col>

          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                  <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.typescripte&hl=en">
                  <Card.Title>Typescript</Card.Title>
                  <Image src={typescript} fluid rounded className="shadow-lg"/>
                  Download
                  </Card.Link>
                  </Card>
          </Col>

          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.are&hl=en">
                <Card.Title>Perl</Card.Title>
                <Image src={perl} fluid rounded className="shadow-lg"/>
                Download
                </Card.Link>
                </Card>
          </Col>

          <Col xs="4" md="3" lg="2" sm="3">
          <Card className="mt-5 shadow-lg" className="text-center">
                  <Card.Link href="https://play.google.com/store/apps/details?id=com.newHMapps.Csharp&hl=en">
                  <Card.Title>Kotlin</Card.Title>
                  <Image src={kotlin} fluid rounded className="shadow-lg"/>
                  Download
                  </Card.Link>
                  </Card>
          </Col>
        </Row>

<br/>










      </div>
    );
  }
}

export default AndroidApps;
